import img1 from "./images/book-1.jpg";
import img2 from "./images/book-2.jpg";
import img3 from "./images/book-3.jpg";
import img4 from "./images/book-4.jpg";
import img5 from "./images/book-5.jpg";
import img6 from "./images/book-6.jpg";

export const books = [
  {
    title: "Outlive",
    img: img1,
    author: "Peter Attia MD",
    id: 1,
  },

  {
    title: "Atomic Habits",
    img: img2,
    author: "James Clear",
    id: 2,
  },
  {
    title: "The 48 Laws of Power",
    img: img3,
    author: "Robert Greene",
    id: 3,
  },

  {
    title: "The Psychology of Money",
    img: img4,
    author: "Morgan Housel",
    id: 4,
  },
  {
    title: "It Starts with Us",
    img: img5,
    author: "Colleen Hoover",
    id: 5,
  },
  {
    title: "Lessons in Chemistry",
    img: img6,
    author: "Bonnie Garmus",
    id: 6,
  },
];
